<template>
  <div class="menu-accessibility">
    <ul class="menu-accessibility__left">
      <li
        v-for="link in visibleLeftLinks"
        :key="link.id"
      >
        <a
          :id="link.id"
          :href="link.href"
          :aria-label="link.label"
          class="menu-accessibility__link"
        >
          <span class="menu-accessibility__icon">
            <svg aria-hidden="true">
              <use :xlink:href="link.icon" />
            </svg>
          </span>
          <p class="menu-accessibility__label">{{ link.label }}</p>
        </a>
      </li>
    </ul>
    <ul class="menu-accessibility__right">
      <li
        v-for="link in visibleRightLinks"
        :key="link.id"
      >
        <a
          :id="link.id"
          :href="link.href"
          :aria-label="link.label"
          tabindex="0"
          class="menu-accessibility__link"
        >
          <span class="menu-accessibility__icon">
            <svg aria-hidden="true">
              <use :xlink:href="link.icon" />
            </svg>
          </span>
          <p class="menu-accessibility__label">{{ link.label }}</p>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  name: 'menu-accessibility',
  props: {
    leftLinks: {
      type: Object
    },
    rightLinks: {
      type: Object
    }
  },
  data() {
    return {
      windowWidth: window.innerWidth,
    }
  },
  computed: {
    isMobile() {
      return this.windowWidth < 1280
    },
    visibleLeftLinks() {
      return this.leftLinks.filter(link => this.shouldShowLink(link) && link.label)
    },
    visibleRightLinks() {
      return this.rightLinks.filter(link => this.shouldShowLink(link) && link.label)
    }
  },
  mounted() {
    window.addEventListener('resize', this.updateWindowWidth)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateWindowWidth)
  },
  methods: {
    updateWindowWidth() {
      this.windowWidth = window.innerWidth
    },
    shouldShowLink(link) {
      if (!link.visibleOn || link.visibleOn === 'all') return true
      if (link.visibleOn === 'mobile') return this.isMobile
      if (link.visibleOn === 'desktop') return !this.isMobile
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-accessibility {
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  background: $blue-03;
  color: $white;
  text-decoration: none;
  padding: 0.25rem 2rem 0.25rem 1.938rem;

  &__right,
  &__left {
    display: flex;
    margin-block-start: unset;
    margin-block-end: unset;
    padding-inline-start: unset;
    gap: 0.3rem;

    @include screen-size('xxl') {
      gap: 0.5rem;
    }
  }

  &__link {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: $white;
    text-decoration: none;
    cursor: pointer;
    border: solid 0.0625rem transparent;
    border-radius: 0.1875rem;

    @media (min-width: 1280px) {
      padding-right: 0.3rem;
    }

    &:hover {
      transition: all 0.8s;
      border: solid 0.0625rem $white;
      outline: solid 0.0625rem $white;
      border-radius: 0.1875rem;
    }

    &:focus {
      outline: solid 0.0625rem $white;
    }
  }

  &__icon {
    display: flex;
    padding: 0.1875rem;

    svg {
      width: 1.5rem;
      height: 1.5rem;
      stroke-width: 0.0938rem;
    }
  }

  &__label {
    display: none;

    @media (min-width: 1280px) {
      display: flex;
      font-size: 0.75rem;
    }
  }
}

// Contrast Mode
.contrast-mode {
  .menu-accessibility {
    &__label {
     &:hover, &:focus {
       color: $black !important;
     }
    }

    &__icon {
      svg {
        fill: $black !important;
        color: $black !important;
      }
    }
  }
}
</style>
